module.exports = __webpack_public_path__ + "img/farewell_14.64b4dfd8.jpg";